<script>
export default {
  name: 'ArtistSelector',
  data() {
    return {
      drawer: false,
      loading: false,
      direction: 'rtl',
      queryString: '',
      dataList: [],
      queryStrSet: []
    }
  },
  methods: {
    handleOpen() {
      this.drawer = true
      this.loading = false
      const lastHistory = localStorage.getItem('kol:selector')
      if (lastHistory) {
        const qArr = JSON.parse(lastHistory)
        this.queryStrSet = qArr || []
        if (this.queryStrSet.length > 0) {
          this.queryString = this.queryStrSet[0]
        }
      }

      this.handleQuery()

    },
    async handleQuery() {
      this.loading = true
      const { list } = await this.$api.searchArtists({ nickname: this.queryString })
      if (this.queryString && this.queryString.length > 0) {
        if (this.queryStrSet.indexOf(this.queryString) === -1)
          this.queryStrSet.push(this.queryString)
      }

      this.dataList = list || []
      setTimeout(() => {
        this.loading = false
        localStorage.setItem('kol:selector', JSON.stringify(this.queryStrSet))
      }, 100)
    },
    handleChangeQuery(val) {
      this.queryString = val
      this.handleQuery()
    },
    handleClose(tag) {
      this.queryStrSet.splice(this.queryStrSet.indexOf(tag), 1)
    },
    handleSelectRow(row) {
      if (row) {
        this.$emit('handleSelected', { artist_id: row.id, nickname: row.nickname })
      }

      // 关闭抽屉
      this.drawer = false
    }
  }
}
</script>

<template>
  <el-drawer
    title='红人选择器'
    :visible.sync='drawer'
    :direction='direction'
    append-to-body
    :modal='false'
  >
    <div class='kol-panel'>
      <div>
        <el-form @submit.native.prevent inline>
          <el-form-item label=''>
            <el-input placeholder='昵称搜索' v-model='queryString' clearable @change='handleQuery'></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' icon='el-icon-search' round @click='handleQuery' :loading='loading'
                       :disabled='loading'>搜索
            </el-button>
          </el-form-item>
        </el-form>
        <div style='padding: 5px;border: #F2F2F2 1px dashed'>
          <el-tag
            style='margin-right: 4px'
            title='点击快捷搜索'
            v-for='item in queryStrSet'
            :key='item'
            type='warning'
            effect='plain'
            @click='handleChangeQuery(item)'
            closable
            @close='handleClose(item)'>
            &nbsp; {{ item }} &nbsp;
          </el-tag>
        </div>
      </div>
      <div v-loading='loading'>
        <el-table :data='dataList' height='600' row-class-name='cursor-pointer' @row-click='handleSelectRow'>
          <el-table-column label='红人昵称' prop='nickname'></el-table-column>
          <el-table-column label='归属部门' prop='group_name'></el-table-column>
          <el-table-column label='签约状态' prop='sign_status'></el-table-column>
          <el-table-column label='签约时间' prop='sign_start'></el-table-column>
        </el-table>
      </div>

    </div>
  </el-drawer>
</template>

<style scoped>
.kol-panel {
  padding: 10px;
}


</style>
